module.exports = __webpack_public_path__ + "static/media/riskpic3@2x.55ea64ac.png";